import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { AuthGuard } from './_guards/auth.guard';  
import { InitialComponent } from './_shared/initial/initial.component';
import { MainComponent } from './_shared/main/main.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { HomeComponent } from './dashboard/home/home.component';
import { ApprovalComponent } from './dashboard/approval/approval.component';
import { QuickDeligationComponent } from './dashboard/quick-deligation/quick-deligation.component';
import { AdvancedDelegationComponent } from './dashboard/advanced-delegation/advanced-delegation.component';
import { DelegationReportsComponent } from './dashboard/delegation-reports/delegation-reports.component';
import { InitiateDelegationComponent } from './dashboard/initiate-delegation/initiate-delegation.component';
import { OnBehalfDelegationComponent } from './dashboard/on-behalf-delegation/on-behalf-delegation.component';
import { ConfigureRoleComponent } from './dashboard/configure-role/configure-role.component';
import { LogoutComponent } from './common/logout/logout.component';
import { MsalGuard } from '@azure/msal-angular';
import { UnAuthorizedComponent } from './auth/un-authorized/un-authorized.component';


   const routes: Routes = [
      { path: '', redirectTo:'/login', pathMatch: 'full' },
      { path: '', component: InitialComponent, children:[
          { path: 'login', component: LoginComponent,canActivate:[MsalGuard]},
          { path: 'forgot', component: ForgotComponent,canActivate:[MsalGuard]},
      ] },
      { path: '', component: MainComponent, children:[
          { path: 'home', component: HomeComponent,canActivate:[MsalGuard] },
          { path: 'approval', component: ApprovalComponent,canActivate:[MsalGuard] },
          { path: 'quick-deligation', component: QuickDeligationComponent,canActivate:[MsalGuard] },
          { path: 'advanceDeligation', component: AdvancedDelegationComponent,canActivate:[MsalGuard] },
          { path: 'delegationReports', component: DelegationReportsComponent,canActivate:[MsalGuard] },
          { path: 'initiateDelegation', component: InitiateDelegationComponent,canActivate:[MsalGuard] },
          { path: 'onBehalfDelegation', component: OnBehalfDelegationComponent,canActivate:[MsalGuard] },
          { path: 'configureRole', component: ConfigureRoleComponent,canActivate:[MsalGuard] },
          { path: 'Logout', component: LogoutComponent,canActivate:[MsalGuard] },
          { path: 'Unauthorized', component: UnAuthorizedComponent,canActivate:[MsalGuard] },              
      ]},
      { path: '**', component: UnAuthorizedComponent }
    ];

  @NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [ RouterModule ]
  })
  export class AppRoutingModule {}
  